// Runtime API URL — always uses the current domain, not the build-time URL
// This ensures the app works on custom domains (e.g. reliefify.com.au)
export const API_BASE = `${window.location.origin}/api`;
